module.exports = __webpack_public_path__ + "static/media/pappershafte.4d9532fe.mp3";